import { useGetOrgGraphQuery } from '@/generated/graphql'
import { Button, OrgGraph } from '@valiant/ui-shared'
import { ChevronLeft } from 'lucide-react'
import { useNavigate, useSearchParams } from 'react-router-dom'

export function OrgGraphPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const groupId = searchParams.get('groupId') ?? undefined
  const companyId = searchParams.get('companyId') ?? undefined
  const userId = searchParams.get('userId') ?? undefined
  const [{ data, fetching: isLoading, error }] = useGetOrgGraphQuery({
    variables: {
      input: {
        groupId,
        companyId,
        userId,
      },
    },
  })
  return (
    <div
      className="overflow-hidden"
      style={{ width: '100vw', height: '100vh', position: 'relative' }}
    >
      <Button
        variant="main_action"
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 z-50 flex items-center gap-0 md:gap-1 rounded-full h-7 md:h-9"
      >
        <ChevronLeft className="h-3 w-3 md:h-4 md:w-4" />
        <span className="text-xs md:text-base">Back</span>
      </Button>
      {isLoading && <div>Loading...</div>}
      {error && <div>Error: {error.message}</div>}
      {data && (
        <OrgGraph
          graph={data.getOrgGraph.nodes.map((node) => ({
            id: node.id,
            name: node.name,
            parentId: node.parentId,
            type: node.type,
          }))}
          onNodeClick={(node) => {
            let search = ''
            if (node.type === 'GROUP') {
              search = 'groupId=' + node.id
            } else if (node.type === 'COMPANY') {
              search = 'companyId=' + node.id
            } else if (node.type === 'USER') {
              search =
                'userId=' + node.id.replace('-group-', ':').replace('-company-', ':').split(':')[0]
            }
            navigate(`/org-graph?${search}`)
          }}
        />
      )}
    </div>
  )
}
